/** @format */

import React, { useState } from 'react'
import { _$, Card } from '@king-design/react'
import styled from 'styled-components'
import MonitorCrumb from 'src/components/MonitorCrumb'
import HeaderFilter from '../components/HeaderFilter'
import { ServiceOverviewSearchProps } from '../components/typescript.js'
import SessionContainer from './container'
import useNavRegion from 'src/hooks/useNavRegion'
import { initSearch } from '../components/constant'

const SessionAnalysis: React.FC<{ className?: string }> = ({ className }) => {
  const [headerSearch, setHeaderSearch] = useState<ServiceOverviewSearchProps>(initSearch())

  const region = useNavRegion()
  return (
    <div className={className}>
      <MonitorCrumb breadArr={[{ title: _$('AI可观测') }, { title: _$('会话分析') }]} />
      <Card className="session-analysis-card" title={_$('会话分析')}>
        <HeaderFilter
          value={headerSearch}
          onChange={val => {
            setHeaderSearch(val)
          }}
          showAggregate={false}
        />
        <SessionContainer region={region} headerSearch={headerSearch} />
      </Card>
    </div>
  )
}

export default styled(SessionAnalysis)`
  padding: 0 16px;
`
